module.exports = __webpack_public_path__ + "static/media/googleplay-badge.56b44686.svg";